import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { SharedFileRequestStatus } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export const selectorIsRequirementReadyToUploadFile = (
  requirement: IRequirementResponse,
  sharedFile?: ISharedFileRequestResponse
): boolean => {
  return (
    !!sharedFile &&
    (selectorIsSharedFileNotNoneContext(sharedFile?.contextType)
      ? sharedFile.status === SharedFileRequestStatus.PendingUpload
      : requirement.dataSourceStatus !== RequirementStatus.Complete)
  );
};
